module.exports = __webpack_public_path__ + "static/media/autooprema.944d9d8f.png";